export default "__VITE_ASSET__CYKOUAIO__"